import React from 'react'
import Sala from '../Sala'
import VerticalConnection from '../Connections/VerticalConnection'
import HorizontalConnection from '../Connections/HorizontalConnection'
import DiagonalConnectionOne from '../Connections/DiagonalConnectionOne'
import DiagonalConnectionTwo from '../Connections/DiagonalConnectionTwo'
//import VerticalConnection2 from '../Connections2/VerticalConnection2'
//import HorizontalConnection2 from '../Connections2/HorizontalConnection2'
// import DiagonalConnection2One from '../Connections2/DiagonalConnection2One'
// import DiagonalConnection2Two from '../Connections2/DiagonalConnection2Two'
import { useState } from "react"
import Animacao from '../Animacao'
import {getNodesId} from '../Animacao';

export const CenarioTeste = ({ start, distancesC0, algorithm }) => { 
    const [startNode, setStartNode] = useState(0)
    // const [isStartNode, setIsStartNode] = useState([])

    // useEffect(() => {
    //     //document.write(`You selected startNode number ${startNode}`)
    //     //document.innerHTLM = `You selected startNode number ${startNode}`
    // }); 

    // const salaOnClick = (id) => {
    //     setStartNode(id)
    //     setIsStartNode(true)
    //     alert("You selected a room")
    // }

    const clearAndStart = (startNodeId) => {   
        document.getElementById('alert-achou-caminho').setAttribute("style", "display:none");  
        if(start === true) { //limpa cenário apenas se estiver 'sujo'
            var nodesInShortestPathOrder = getNodesId()
            if(nodesInShortestPathOrder !== undefined && nodesInShortestPathOrder !== null)
                clearNodesConnections(nodesInShortestPathOrder)
        }
        setStartNode(startNodeId)
    }
      
    const clearNodesConnections = (nodesInShortestPathOrder) => {
        var classNameOrig, classNameConnectionV, classNameConnectionH, classNameConnectionD1, classNameConnectionD2
        classNameOrig = 'sala'
        classNameConnectionV = 'vertical-connection'
        classNameConnectionH = 'horizontal-connection'
        classNameConnectionD1 = 'diagonal-connection-one'
        classNameConnectionD2 = 'diagonal-connection-two'
      
        for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
          //Limpar salas
          const node = nodesInShortestPathOrder[i];
          document.getElementById(`${node}`).children.item(0).className = classNameOrig;
      
          //Limpar connections
          if(i !== nodesInShortestPathOrder.length - 1) { 
            let node1 = nodesInShortestPathOrder[i];
            let node2 = nodesInShortestPathOrder[i+1];
            if (node1 > node2) {
              let aux = node1;
              node1 = node2;
              node2 = aux;
            }
            const connectionId = parseInt('1' + node1.toString() + node2.toString(), 10);
            const connectionType = document.getElementById(`${connectionId}`).children.item(0).id;
           if(connectionType === '111') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionV;
            } else if(connectionType === '222') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionH;
            } else if(connectionType === '333') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD1;
            } else if(connectionType === '444') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD2;
            }           
          }
        }
    }

    return (
        <>
            {/* CENÁRIO */} 
            <div>
                <Sala isTransparente={true}/>
                <VerticalConnection isTransparente={true}/>
                
                <div id={0}><Sala onClick={() => clearAndStart(0)}/> </div>
                <VerticalConnection isTransparente={true}/>
               
                <Sala isTransparente={true}/>
            </div>
            <div>
                <HorizontalConnection isTransparente={true}/>  {/* margemAcima={40} */}
                {/* <div style={{ float: 'left'}}> <HorizontalConnection2/> </div> */}
                <div id={101}><DiagonalConnectionOne distance={distancesC0[0].toFixed(1)}/></div>                   
                <div id={102}><HorizontalConnection margemAcima={40} distance={distancesC0[1].toFixed(1)}/></div>
                <div id={103}><DiagonalConnectionTwo distance={distancesC0[2].toFixed(1)}/></div>                
            </div>
            <div>
                <div id={1}><Sala onClick={() => clearAndStart(1)}/> </div>
                <div id={112}><VerticalConnection distance={distancesC0[3].toFixed(1)}/></div>
                
                <div id={2}><Sala onClick={() => clearAndStart(2)}/></div> 
                <div id={123}><VerticalConnection distance={distancesC0[4].toFixed(1)}/></div>

                <div id={3}><Sala onClick={() => clearAndStart(3)}/></div> 
            </div>
            <div>
                <HorizontalConnection isTransparente={true}/>
                <div id={114}><DiagonalConnectionTwo distance={distancesC0[5].toFixed(1)}/></div>                   
                <div id={124}><HorizontalConnection margemAcima={40} distance={distancesC0[6].toFixed(1)}/></div>               
            </div>
            <div>
                <Sala isTransparente={true}/>
                <VerticalConnection isTransparente={true}/>
                
                <div id={4}><Sala onClick={() => clearAndStart(4)}/> </div>
                <VerticalConnection isTransparente={true}/>
               
                <Sala isTransparente={true}/>
            </div>
            <div>
                <HorizontalConnection isTransparente={true}/> 
                <div id={145}><DiagonalConnectionOne distance={distancesC0[7].toFixed(1)}/></div>                   
                <HorizontalConnection isTransparente={true}/>
                <div id={147}><DiagonalConnectionTwo distance={distancesC0[8].toFixed(1)}/></div>                
            </div>
            <div>
                <div id={5}><Sala onClick={() => clearAndStart(5)}/> </div>
                <div id={156}><VerticalConnection distance={distancesC0[9].toFixed(1)}/></div>
                
                <div id={6}><Sala onClick={() => clearAndStart(6)}/></div> 
                <div id={167}><VerticalConnection distance={distancesC0[10].toFixed(1)}/></div>

                <div id={7}><Sala onClick={() => clearAndStart(7)}/></div> 
            </div>
            <div>
                <HorizontalConnection isTransparente={true}/>  
                <DiagonalConnectionOne isTransparente={true}/>                   
                <div id={168}><HorizontalConnection margemAcima={40} distance={distancesC0[11].toFixed(1)}/></div>
                <div id={178}><DiagonalConnectionOne distance={distancesC0[12].toFixed(1)}/></div>                
            </div>
            <div>
                <Sala isTransparente={true}/>
                <VerticalConnection isTransparente={true}/>
                
                <div id={8}><Sala onClick={() => clearAndStart(8)}/> </div>
                <VerticalConnection isTransparente={true}/>
               
                <Sala isTransparente={true}/>
            </div>
            <div>
                <HorizontalConnection isTransparente={true}/> 
                <div id={189}><DiagonalConnectionOne distance={distancesC0[13].toFixed(1)}/></div>                   
                <HorizontalConnection isTransparente={true}/>
                <div id={1810}><DiagonalConnectionTwo distance={distancesC0[14].toFixed(1)}/></div>                
            </div>
            <div>
                <div id={9}><Sala onClick={() => clearAndStart(9)}/> </div>
                <VerticalConnection isTransparente={true}/>
                
                <Sala isTransparente={true}/>
                <VerticalConnection isTransparente={true}/>

                <div id={10}><Sala onClick={() => clearAndStart(10)}/></div> 
            </div>
            <div>
                <HorizontalConnection isTransparente={true}/>
                <div id={1911}><DiagonalConnectionTwo distance={distancesC0[15].toFixed(1)}/></div>                   
                <HorizontalConnection isTransparente={true}/> 
                <div id={11011}><DiagonalConnectionOne distance={distancesC0[16].toFixed(1)}/></div>              
            </div>
            <div>
                <Sala isTransparente={true}/>
                <VerticalConnection isTransparente={true}/>
                
                <div id={11}><Sala onClick={() => clearAndStart(11)}/> </div>
                <VerticalConnection isTransparente={true}/>
               
                <Sala isTransparente={true}/>
            </div>

            {/* COMEÇAR ANIMAÇÃO*/}
            {start && <Animacao start={start} startNode={startNode} idCenario={0} distances={distancesC0} algorithm={algorithm}/>}
        </>
    )
}

export default CenarioTeste